import { useSelector } from 'react-redux';
import _get from 'lodash/get';

export default function useOrgPlanningEnabled() {
  const orgPlanningIsEnabled = useSelector(state =>
    _get(state, 'client.settings.orgPlanning.enabled', false),
  );

  const personIsAdmin = useSelector(state =>
    _get(state, 'authentication.person.account.isAdmin', false),
  );

  const canCreateOrgPlan = useSelector(
    state => !!_get(state, ['authentication', 'person', 'permissions', 'create-org-plan']),
  );

  const hasSharedOrgPlanAccess = useSelector(
    state =>
      _get(
        state,
        ['authentication', 'person', 'permissions', 'edit-org-plan', '_includedScopedObjectIds'],
        [],
      ).length > 0,
  );

  return orgPlanningIsEnabled && (personIsAdmin || canCreateOrgPlan || hasSharedOrgPlanAccess);
}
